import { getHttpClient } from './http-client.factory';
import { HttpSettingsRepository } from '../../infrastructure/repositories/http-settings.repository';

let settingsRepository: HttpSettingsRepository | null = null;

export const getSettingsRepository = (): HttpSettingsRepository => {
  if (!settingsRepository) {
    settingsRepository = new HttpSettingsRepository(getHttpClient());
  }
  return settingsRepository;
};
